// Override
var LayoutChildren = function () {

}

export default LayoutChildren;